import React from 'react'
import styled from 'styled-components'
import ArrowBackIosRoundedIcon from '@material-ui/icons/ArrowBackIosRounded'
import ArrowForwardIosRoundedIcon from '@material-ui/icons/ArrowForwardIosRounded'
import theme from 'theme'

const arrowStyle = { color: theme.color.blue200, fontSize: 18 }

export const PrevButton = ({ hide, onClick }) => {
  return (
    <PrevPosition hide={hide} onClick={onClick}>
      <ArrowBackIosRoundedIcon style={arrowStyle} />
    </PrevPosition>
  )
}
export const NextButton = ({ hide, onClick }) => {
  return (
    <NextPosition hide={hide} onClick={onClick}>
      <ArrowForwardIosRoundedIcon style={arrowStyle} />
    </NextPosition>
  )
}

const ButtonWapper = styled.div`
  width: 32px;
  height: 32px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  background-color: ${(p) => p.theme.color.white};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  cursor: pointer;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
`

const PrevPosition = styled(ButtonWapper)`
  left: -16px;
  display: ${(p) => p.hide && 'none'};
`
const NextPosition = styled(ButtonWapper)`
  right: -16px;
  display: ${(p) => p.hide && 'none'};
`
